module.exports = __webpack_public_path__ + "assets/Retina-ExLightItalic.97bf1a48fde60b7ecc0f70344776f524.woff";